import Container from "@mui/material/Container";
import { Link } from "react-router-dom";

import useStyles from "./style";

const date = new Date();
let year = date.getFullYear();

const Footer = () => {
  const classes = useStyles();

  return (
    <footer className={classes.footer}>
      <Container>
        <div className={classes.footerContainer}>
          <ul className={classes.leftSide}>
            <li>ՀայՓոստ ՓԲԸ {year} © </li>
            <li>Բոլոր իրավունքները պաշտպանված են</li>
          </ul>

          <div className={classes.rightSide}>
            <Link
              to="/terms-and-conditions"
              className={classes.termsConditionslink}
            >
              Դրույթներ և պայմաններ{" "}
            </Link>
            <ul className={classes.copyRight}>
              <li>
                <a
                  className={classes.footerMailTo}
                  href="mailto:info@haypost.am"
                >
                  info@haypost.am
                </a>
              </li>
              <li> Սարյան 22, +374 10 514 514</li>
            </ul>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
